module.exports = __webpack_public_path__ + "img/Group 5918.b5508dd7.svg";